import React, { useEffect, useState } from 'react';
import contract from './contracts/SplicerContract.json';
import stakingContract from './contracts/StakingContract.json';
import oldStakingContract from './contracts/OldStakingContract.json';

import { ethers } from 'ethers';
import { parse } from '@ethersproject/transactions';
import { render } from '@testing-library/react';  
import gallery from './Gallery'


const contractAddress = "0xfD4BfE64fea2ce11898c4b931AFAF728778a90b4";
const stakingContractAddress = "0x7d531a46b004792d50b6DF158C8bC15bAb30706B";
//const stakingContractAddress = "0xd87622f05A414D7816cCd3254089AedF08922C3D";
const oldStakingContractAddress = "0xf80faba16B4757598c6FaD1Fe4134039649cB099";
const maxRewardSplicers = new Array(0,278,534,856,878,879,880,1058,1322,2041,616,973,422,632,981,2491,2492,2493)


const abi = contract;
const stakingabi = stakingContract;
const oldStakingabi = oldStakingContract;

function App() {

  const [currentAccount, setCurrentAccount] = useState(null);
  const [tokens, setTokens] = useState(null);
  const [tokensRewards, setTokensRewards] = useState(null);
  const [stakedTokens, setStakedTokens] = useState(null);
  const [stakedTokensTime, setStakedTokensTime] = useState(null);
  const [stakedTokensRewards, setStakedTokensRewards] = useState(null);
  const [oldStakedTokens, setOldStakedTokens] = useState(null);
  const [oldStakedTokensTime, setOldStakedTokensTime] = useState(null);
  const [stakingPeriod, setStakingPeriod] = useState(null);
  const [restakingPeriod, setRestakingPeriod] = useState(null);
  const [showRestakeButton, setShowRestakeButton] = useState(false);

  const [showPage, setShowPage] = useState(1); //1 = unstaked, 2 = staked, 3 = oldStaked
  const connectAccountDOM = document.getElementById('accountDetails')

  const checkWalletIsConnected = async () => {
    const { ethereum } = window;

    //Check metamask installed
    if (!ethereum) {
      window.addEventListener('ethereum#initialized', checkWalletIsConnected, {
        once: true,
      });
    
      // If the event is not dispatched by the end of the timeout,
      // the user probably doesn't have MetaMask installed.
      setTimeout(checkWalletIsConnected, 3000);
      console.log("Make sure you have Metamask installed!");
      return
    }

    const provider = new ethers.providers.Web3Provider(ethereum);
    const addresses = await provider.listAccounts(); 
    if (addresses.length !== 0) setCurrentAccount(addresses[0]);
    //this.setState({currentAccount : addresses[0]});s

    //GetImages();
  }

  const connectWalletHandler = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      alert("Please install Metamask!");
    }

    try {
      const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
      console.log("Found an account! Address: ", accounts[0]);
      setCurrentAccount(accounts[0]);
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    console.log(currentAccount);

    if (!currentAccount) 
    {
      connectAccountDOM.innerHTML = 'Connect Wallet';
      connectAccountDOM.setAttribute('href', '#');
      connectAccountDOM.setAttribute('style', 'cursor: pointer');

      connectAccountDOM.onclick = () => connectWalletHandler();
      return;
    }

    connectAccountDOM.innerHTML = String(currentAccount);
    connectAccountDOM.removeAttribute('href');
    connectAccountDOM.setAttribute('style', '');
    connectAccountDOM.onclick = null;
    GetTokens();
  }, [currentAccount, connectAccountDOM]) 

  useEffect(() => {
    if (currentAccount === null) checkWalletIsConnected();
  });

  //Images
  const GetTokens = async () => 
  {
    const { ethereum } = window;
    if (!ethereum || !currentAccount) return;

    const provider = new ethers.providers.Web3Provider(ethereum);
    const signer = provider.getSigner();
    const nftContract = new ethers.Contract(contractAddress, abi, signer);
    const nftStakingContract = new ethers.Contract(stakingContractAddress, stakingabi, signer);
    const oldNftStakingContract = new ethers.Contract(oldStakingContractAddress, oldStakingabi, signer);


    const tokenIDs = await nftContract.walletOfOwner(currentAccount);
    const parsedIDs = tokenIDs.map(i => parseInt(i));
    parsedIDs.sort(function(a, b) {
      return a - b;
    });

    const stakedTokenIDs = await nftStakingContract.walletOfOwner(currentAccount);
    const parsedStakedIDs = stakedTokenIDs.map(i => parseInt(i));
    parsedStakedIDs.sort(function(a, b) {
      return a - b;
    });

    const stakedTimes = await Promise.all(parsedStakedIDs.map(
      i => nftStakingContract.getTimeRemaining(i)
    ));
    const parsedstakedTimes = stakedTimes.map(i => parseInt(i));

    const rewards = await Promise.all(parsedStakedIDs.map(
      async (i) => {
        let prom = await nftStakingContract.stakedNFTs(i);
        let reward = [...prom];
        if (maxRewardSplicers.includes(i))
        {
          reward[2] = 4;
          reward[3] = 2;
          reward[4] = 1;
        }
        return reward;
      }
    ));

    console.log(rewards);

    const unstakedRewards = await Promise.all(parsedIDs.map(
      async (i) => {
        let prom = await nftStakingContract.stakedNFTs(i);
        let reward = [...prom];
        if (maxRewardSplicers.includes(i))
        {
          reward[2] = 4;
          reward[3] = 2;
          reward[4] = 1;
        }
        return reward;
      }
    ));

    //console.log(unstakedRewards);
    //const parsedRewards = stakedTimes.map(i => parseInt(i));

    const oldStakedTokenIDs = await oldNftStakingContract.walletOfOwner(currentAccount);
    const oldParsedStakedIDs = oldStakedTokenIDs.map(i => parseInt(i));
    oldParsedStakedIDs.sort(function(a, b) {
      return a - b;
    });

    const oldStakedTimes = await Promise.all(oldParsedStakedIDs.map(
      i => oldNftStakingContract.getTimeRemaining(i)
    ));
    const oldParsedstakedTimes = oldStakedTimes.map(i => parseInt(i));

    //console.log(parsedstakedTimes);

    //document.getElementById('img1').setAttribute("src", `https://api.soulsplicers.com/image/${ints[0]}`);
    //document.getElementById('img2').setAttribute("src", `https://api.soulsplicers.com/image/${ints[1]}`);
    //console.log(ints);

    setTokens(parsedIDs);
    setTokensRewards(unstakedRewards);
    setStakingPeriod(new Array(parsedIDs.length).fill(0));
    setStakedTokens(parsedStakedIDs);
    setRestakingPeriod(new Array(parsedStakedIDs.length).fill(0));
    setStakedTokensTime(parsedstakedTimes);
    setStakedTokensRewards(rewards);
    setOldStakedTokens(oldParsedStakedIDs);
    setOldStakedTokensTime(oldParsedstakedTimes);
    //SetTestValues();
  }

  const SetTestValues = () => {
    setTokens([0,1,2]);
    setStakingPeriod(new Array(3).fill(0));
    setStakedTokens([0,1,2]);
    setRestakingPeriod(new Array(3).fill(0));
    setStakedTokensTime([346346,45634,0]);
    setOldStakedTokens([0,1,2]);
    setOldStakedTokensTime([346346,45634,0]);
    setTokensRewards(new Array(new Array(0, 0, 4, 2, 1), new Array(0, 0, 2, 1, 0), new Array(0, 0, 1, 0, 0)));
    setStakedTokensRewards(new Array(new Array(0, 0, 4, 2, 1), new Array(0, 0, 2, 1, 0), new Array(0, 0, 1, 0, 0)));
  }

  const GetPeriod = (timeRemaining) => {
    if (timeRemaining > 10370000) return 5;
    if (timeRemaining > 5185000) return 3;
    return 1;
  };

  const handlePeriodChange = (event, index) => {
    let _stakingPeriod = stakingPeriod;
    _stakingPeriod[index] = event.target.value;
    setStakingPeriod(_stakingPeriod);
    forceUpdate();
  };

  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  const handlePeriodChangeStaked = (event, index) => {
    let _stakingPeriod = restakingPeriod;
    console.log(_stakingPeriod);
    _stakingPeriod[index] = event.target.value;
    setRestakingPeriod(_stakingPeriod);
    forceUpdate();
    return;

    let _stakingPeriodNew = Object.values({ ...restakingPeriod });
    for (let i = _stakingPeriodNew.length - 1; i >= 0; i--) {
      if (_stakingPeriodNew[i] == 0) {
        _stakingPeriodNew.splice(i, 1)
      }
    }
    if (_stakingPeriodNew.length == 0) setShowRestakeButton(false);
    setShowRestakeButton(true);
  };
  
  const Stake = async () => {
    let _tokens = Object.values({ ...tokens });
      let _stakingPeriod = Object.values({ ...stakingPeriod });
      for (let i = _stakingPeriod.length - 1; i >= 0; i--) {
        if (_stakingPeriod[i] == 0) {
          _tokens.splice(i, 1);
          _stakingPeriod.splice(i, 1)
        }
      }
    if (_stakingPeriod.length == 0) return;
    console.log(_tokens);
    console.log(_stakingPeriod);
    document.getElementById('overlay').style.display = 'block';

    try {      
      const { ethereum } = window;
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      const nftContract = new ethers.Contract(contractAddress, abi, signer);
      const nftStakingContract = new ethers.Contract(stakingContractAddress, stakingabi, signer);
      const transfersAllowed = await nftContract.isApprovedForAll(currentAccount, stakingContractAddress);

      //const oldNftStakingContract = new ethers.Contract(oldStakingContractAddress, oldStakingabi, signer);
      //const setEarlyRelease = await nftStakingContract.setEarlyRelease(true);
      //await setEarlyRelease.wait();

      if (!transfersAllowed) {
        document.getElementById('transaction-step').innerHTML = "Transaction 1/2 - Contract Approval";
        let approvalTXN = await nftContract.setApprovalForAll(stakingContractAddress, true);
        await approvalTXN.wait();
      }
      document.getElementById('transaction-step').innerHTML = "Transaction 2/2 - Staking Splicers";
      let stakingTXN = await nftStakingContract.stake(_tokens, _stakingPeriod);
      await stakingTXN.wait();
      document.getElementById('overlay').style.display = 'none';
      GetTokens();

      console.log(_tokens);
      console.log(_stakingPeriod);
      console.log(tokens);
      console.log(stakingPeriod);
      console.log(transfersAllowed)

    } catch {
      document.getElementById('overlay').style.display = 'none';
    }
    
  };

  const Restake = async () => {
    let _tokens = oldStakedTokens;
    document.getElementById('overlay').style.display = 'block';
    document.getElementById('transaction-step').innerHTML = "";
    console.log(_tokens);

    try {      
      const { ethereum } = window;
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      const nftContract = new ethers.Contract(contractAddress, abi, signer);
      const nftStakingContract = new ethers.Contract(stakingContractAddress, stakingabi, signer);
      const oldNftStakingContract = new ethers.Contract(oldStakingContractAddress, oldStakingabi, signer);
      const transfersAllowed = await nftContract.isApprovedForAll(currentAccount, stakingContractAddress);
      if (!transfersAllowed) {
        document.getElementById('transaction-step').innerHTML = "Transaction 1/3 - Contract Approval";
        let approvalTXN = await nftContract.setApprovalForAll(stakingContractAddress, true);
        await approvalTXN.wait();
      }
      document.getElementById('transaction-step').innerHTML = "Transaction 2/3 - Unstaking Splicers";
      let unStakingTXN = await oldNftStakingContract.unstake(_tokens);
      await unStakingTXN.wait();


      document.getElementById('transaction-step').innerHTML = "Transaction 3/3 - Restaking Splicers";
      let stakingTXN = await nftStakingContract.stakeFromOldContract(_tokens);
      await stakingTXN.wait();
      document.getElementById('overlay').style.display = 'none';
      GetTokens();
      setShowPage(2);

      console.log(_tokens);
      console.log(transfersAllowed)

    } catch {
      document.getElementById('overlay').style.display = 'none';
    }    
  };

  const Unstake = async () => {
    let _tokens = oldStakedTokens;
    document.getElementById('overlay').style.display = 'block';

    console.log(_tokens);

    try {      
      const { ethereum } = window;
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      const nftStakingContract = new ethers.Contract(oldStakingContractAddress, oldStakingabi, signer);
      document.getElementById('transaction-step').innerHTML = "Transaction 1/1 - Unstaking Splicers";
      let stakingTXN = await nftStakingContract.unstake(_tokens);
      await stakingTXN.wait();
      document.getElementById('overlay').style.display = 'none';
      GetTokens();
      setShowPage(1);

      console.log(_tokens);

    } catch {
      document.getElementById('overlay').style.display = 'none';
    }    
  };

  const RestakeUnstake = async () => {
    let _tokens = stakedTokens;
    let _tokensRestake = Object.values({ ...stakedTokens });
      let _stakingPeriod = Object.values({ ...restakingPeriod });
      for (let i = _stakingPeriod.length - 1; i >= 0; i--) {
        if (_stakingPeriod[i] == 0 || _stakingPeriod[i] == 6) {
          _tokensRestake.splice(i, 1);
          _stakingPeriod.splice(i, 1)
        }
      }
    let _tokensUnstake = Object.values({ ...stakedTokens });
      let _stakingPeriodTemp = Object.values({ ...restakingPeriod });
      for (let i = _stakingPeriodTemp.length - 1; i >= 0; i--) {
        if (_stakingPeriodTemp[i] != 6) {
          _tokensUnstake.splice(i, 1);
        }
      }

    console.log(_tokensRestake);
    console.log(_stakingPeriod);    
    console.log(_tokensUnstake);

    if (_stakingPeriod.length == 0 && _tokensUnstake.length == 0) return;
    document.getElementById('overlay').style.display = 'block';
    document.getElementById('transaction-step').innerHTML = "";

    try {      
      const { ethereum } = window;
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      const nftStakingContract = new ethers.Contract(stakingContractAddress, stakingabi, signer);

      let txCount = 0;
      let currentTx = 1;
      txCount = _stakingPeriod.length > 0 ? txCount + 1 : txCount;
      txCount = _tokensUnstake.length > 0 ? txCount + 1 : txCount;


      if (_tokensUnstake.length > 0) {
        document.getElementById('transaction-step').innerHTML = "Transaction " + currentTx + "/" + txCount + " - Unstaking Splicers";
        let unStakingTXN = await nftStakingContract.unstake(_tokensUnstake);
        await unStakingTXN.wait();
        currentTx += 1;
      }
      
      if (_stakingPeriod.length > 0) {
        document.getElementById('transaction-step').innerHTML = "Transaction " + currentTx + "/" + txCount + " - Restaking Splicers";
        let stakingTXN = await nftStakingContract.restake(_tokensRestake, _stakingPeriod);
        await stakingTXN.wait();
        currentTx += 1;
      }

      document.getElementById('overlay').style.display = 'none';
      GetTokens();
      setShowPage(2);

    } catch {
      document.getElementById('overlay').style.display = 'none';
    }    
  };

  const DisplayViewButtons = () => {
    if (!tokens) return null;
    return (
      <div class="staking-view-row">
        <div class={"staking-view-button " + (showPage == 1 ? "selectedView" : "unselected-view")} onClick={showPage == 1 ? null : event=>SwitchView(1)}>Splicers</div>
        <div class={"staking-view-button " + (showPage == 2 ? "selectedView" : "unselected-view")} onClick={showPage == 2 ? null : event=>SwitchView(2)}>Staked Splicers</div>
        {oldStakedTokens != null && oldStakedTokens.length > 0 ? <div class={"staking-view-button " + (showPage == 3 ? "selectedView" : "unselected-view")} onClick={showPage == 3 ? null : event=>SwitchView(3)}>Staked Splicers (Old)</div> : null}
      </div>
    )
  }

  const DisplayTokens = () => {
    if (!tokens) return null;
    if (!tokensRewards) return null;
    if (!stakingPeriod) return null;
    if (tokens.length === 0) return (<div class="staking-view-button unselected-view">No Splicers!</div>);
    return tokens.map((image, index) => (
      <div key={image.toString()} class="token-grid-item">
      <div class="token-image"><img src={`${process.env.PUBLIC_URL}/original/${image}.png`} loading="lazy" alt=""></img></div>
      <div class="token-title">Splicer #{image.toString()}</div>
      {GetRewardText(tokensRewards[index][2], tokensRewards[index][3], tokensRewards[index][4])}
      {GetRewardModifier(tokensRewards[index][2], tokensRewards[index][3], tokensRewards[index][4], stakingPeriod[index])}
      <label class="staking-period">
        <select defaultValue={stakingPeriod[index]} class="staking-period-select" onChange={event=>handlePeriodChange(event, index)}>
          <option value="0">Don't Stake</option>
          {(tokensRewards[index][2] < 4) ? <option value="1">1 Month</option> : null}
          {(tokensRewards[index][3] == 0) ? <option value="3">3 Months</option> : null}
        </select>
      </label>
    </div>
    ))
  }

  const DisplayStakedTokens = () => {
    if (!stakedTokens) return null;
    if (stakedTokens.length === 0) return (<div class="staking-view-button unselected-view">No Splicers!</div>);
    return stakedTokens.map((image, index) => (
      <div key={image.toString()} class="token-grid-item">
      <div class="token-image"><img src={`${process.env.PUBLIC_URL}/original/${image}.png`} loading="lazy" alt=""></img></div>
      <div class="token-title">Splicer #{image.toString()}</div>
      {GetRewardText(stakedTokensRewards[index][2], stakedTokensRewards[index][3], stakedTokensRewards[index][4])}
      {GetRewardModifier(stakedTokensRewards[index][2], stakedTokensRewards[index][3], stakedTokensRewards[index][4], restakingPeriod[index])}
      {(stakedTokensTime[index] > 0) ? <div class="token-title">{Math.ceil(stakedTokensTime[index]/86400)} Days Left</div> : null}
      {(stakedTokensTime[index] <= 0) ?
        <label class="staking-period">
          <select defaultValue={restakingPeriod[index]} class="staking-period-select" onChange={event=>handlePeriodChangeStaked(event, index)}>
            <option value="0">Do Nothing</option>
            {(stakedTokensRewards[index][2] < 4) ? <option value="1">1 Month</option> : null}
            {(stakedTokensRewards[index][3] == 0) ? <option value="3">3 Months</option> : null}
            <option value="6">Unstake</option>
          </select>
        </label> 
        : null}
    </div>
    ))
  }

  const GetRewardText = (t1, t2, t3) => {
    return (
      <div class="token-title">T1:<span style={{color: '#1135d6'}}>{t1}</span> T2:<span style={{color: '#ad09ed'}}>{t2}</span> T3:<span style={{color: '#ff8000'}}>{t3}</span></div>
    );
  }

  const GetRewardModifier = (t1, t2, t3, stakingPeriodSelected) => {
    if (t1 === 4 && t2 === 2 && t3 === 1) return (<div class="token-title">Max Rewards</div>)
    if (t1 === 4 && t2 > 0) return (<div class="token-title">No More to Earn</div>)
    //if (stakingPeriodSelected == 1 && t1 === 4) return (<div class="token-title">Max Rewards</div>)
    if (stakingPeriodSelected == 1) return (<div class="token-title" style={{color: '#1135d6'}}>+1 <span style={{color: '#ad09ed'}}>+0 </span><span style={{color: '#ff8000'}}>+0</span></div>)
    //if (stakingPeriodSelected == 3 && t2 > 0) return (<div class="token-title">Max Rewards</div>)
    if (stakingPeriodSelected == 3) return (<div class="token-title" style={{color: '#1135d6'}}>+2 <span style={{color: '#ad09ed'}}>+1 </span><span style={{color: '#ff8000'}}>+0</span></div>)
    return null;
  }

  const DisplayOldStakedTokens = () => {
    if (!oldStakedTokens) return null;
    if (oldStakedTokens.length === 0) return (<div class="staking-view-button unselected-view">No Splicers!</div>);
    return oldStakedTokens.map((image, index) => (
      <div key={image.toString()} class="token-grid-item">
      <div class="token-image"><img src={`${process.env.PUBLIC_URL}/original/${image}.png`} loading="lazy" alt=""></img></div>
      <div class="token-title">Splicer #{image.toString()}</div>
      <div class="token-title">{Math.ceil(oldStakedTokensTime[index]/86400)} Days Left</div>
    </div>
    ))
  }

  const ShowTokens = () => {
    if (showPage == 1) return DisplayTokens();
    if (showPage == 2) return DisplayStakedTokens();
    if (showPage == 3) return DisplayOldStakedTokens();
    return null;
  }

  const SwitchView = (view) => {
    setShowPage(view);
  }

  const ShouldShowStakeButton = () => {
    let _tokens = Object.values({ ...tokens });
    let _stakingPeriod = Object.values({ ...stakingPeriod });
    for (let i = _stakingPeriod.length - 1; i >= 0; i--) {
      if (_stakingPeriod[i] == 0) {
        _tokens.splice(i, 1);
        _stakingPeriod.splice(i, 1)
      }
    }
    console.log(_stakingPeriod.length);
    if (_stakingPeriod.length == 0) return false;
    return true;
  }

  const ShouldShowRestakeButton = () => {
    let _stakingPeriod = Object.values({ ...restakingPeriod });
    for (let i = _stakingPeriod.length - 1; i >= 0; i--) {
      if (_stakingPeriod[i] == 0) {
        _stakingPeriod.splice(i, 1)
      }
    }
    if (_stakingPeriod.length == 0) return false;
    return true;
  }

  if (!currentAccount) return (
    <div class="token-bg" id="root">
      <noscript>You need to enable JavaScript to run this app.</noscript>
      <a href="#" class="button" style={{position: "absolute", top: "50%", left:"50%", transform: "translate(-50%, -50%)"}} onClick={connectWalletHandler}>Connect Wallet</a>
    </div>
  );

  return (
    <div class="token-bg" id="root">
      <noscript>You need to enable JavaScript to run this app.</noscript>
      <DisplayViewButtons />
      <div class="token-grid">
        <ShowTokens />        
      </div>
      {(showPage === 1) ? <a id="stakebutton" class="button stake-button" onClick={Stake}>Stake</a> : null}
      {(showPage === 3) ? <a id="unstakeallbutton" class="button stake-button" onClick={Unstake}>Unstake All</a> : null}
      {(showPage === 2) ? <a id="stakebutton" class="button stake-button" onClick={RestakeUnstake}>Unstake/Restake</a> : null}

    </div>    
  )
}

export default App;
